export const hexToRgba = async (hex, opacity) => {
  const { default: tinycolor } = await import('tinycolor2');

  return tinycolor(hex).setAlpha(opacity).toRgbString();
};
